import React, { useState, useEffect } from "react";
import { Card, Row, Col, Select, Typography, Table } from "antd";
import {
    DesktopOutlined,
    EnvironmentOutlined,
    ClusterOutlined,
    TabletOutlined,
    UserOutlined,
    PlaySquareOutlined,
    PictureOutlined,
} from "@ant-design/icons";

import StatCard from "../components/Dashboard/StatCard";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;
const { Option } = Select;

const Dashboard = () => {
    const navigate = useNavigate();
    const [selectedCity, setSelectedCity] = useState("");
    const [selectedLocation, setSelectedLocation] = useState("");
    const [userViewPermission, setUserViewPermission] = useState(false);
    const [citiesViewPermission, setCitiesViewPermission] = useState(false);
    const [locationsViewPermission, setLocationsViewPermission] = useState(false);

    const [modalData, setModalData] = useState([]);
    const [modalTitle, setModalTitle] = useState("");
    const [modalColumns, setModalColumns] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Sample data
    const cities = [
        { id: 1, name: "Delhi" },
        { id: 2, name: "Mumbai" },
        { id: 3, name: "Bengaluru" },
        { id: 4, name: "Chennai" },
        { id: 5, name: "Kolkata" },
        { id: 6, name: "Hyderabad" },
        { id: 7, name: "Patna" },
        { id: 8, name: "Gurgaon" },
        { id: 9, name: "Surat" },
        { id: 10, name: "Vizag" },
    ];
    const locations = [
        { id: 203, name: "Prestige Obelisk ", code: "PO", city_id: 6, city_name: "Bengaluru" },
        { id: 131, name: "Prestige Trade Tower", code: "PTT", city_id: 6, city_name: "Bengaluru" },
        { id: 191, name: "Prestige Trade Tower 1st Floor", code: "PTT1", city_id: 6, city_name: "Bengaluru" },
        { id: 132, name: "Prestige Trade Tower 5th Floor", code: "PTT5", city_id: 6, city_name: "Bengaluru" },
        { id: 323, name: "Global Infocity Park Block C, 11th Floor", code: "GIPC11", city_id: 3 },
        { id: 324, name: "Global Infocity Park Block C, 12th Floor", code: "GIPC12", city_id: 3 },
        { id: 101, name: "KRC Commerzone", code: "KRC", city_id: 3, city_name: "Chennai", parent_id: null },
        { id: 372, name: "DLF Cyber City, Building 6 ", code: "DLFCB6", city_id: 4, city_name: "Gurgaon" },
        { id: 374, name: "DLF Cyber City, Building 6, 5th Floor", code: "DLFCB65", city_id: 4 },
        { id: 303, name: "Unitech Signature Towers C, 7th Floor", code: "USTC7", city_id: 4 },
        { id: 304, name: "Unitech Signature Towers C, 8th Floor", code: "USTC8", city_id: 4 },
        { id: 305, name: "Unitech Signature Towers C, 9th Floor", code: "USTC9", city_id: 4 },
        { id: 365, name: "Oberoi Commerz III, 49th Floor", code: "OBECO49", city_id: 2, city_name: "Mumbai" },
        { id: 69, name: "Peninsula Business Park", code: "PBP", city_id: 2, city_name: "Mumbai" },
        { id: 109, name: "Peninsula Business Park 10th Floor", code: "PBP10", city_id: 2, city_name: "Mumbai" },
        { id: 112, name: "BPTP Capital City 9th Floor", code: "BPTPCC9", city_id: 5, city_name: "Noida" },
        { id: 338, name: "DLF Tech Park, 1st Floor ", code: "DLFTP1", city_id: 5, city_name: "Noida" },
        { id: 106, name: "My Home Twitza 12th Floor", code: "MHT12", city_id: 1, city_name: "Vizag" },
        { id: 107, name: "My Home Twitza 14th Floor", code: "MHT14", city_id: 1, city_name: "Vizag" }
    ];
    const screens = [
        { id: 1, name: "Screen 1", city: "Delhi", location: "Connaught Place" },
        { id: 2, name: "Screen 2", city: "Mumbai", location: "Bandra" },
        { id: 3, name: "Screen 3", city: "Bengaluru", location: "MG Road" },
        { id: 4, name: "Screen 4", city: "Delhi", location: "Connaught Place" },
        { id: 5, name: "Screen 5", city: "Mumbai", location: "Bandra" },
        { id: 6, name: "Screen 6", city: "Bangalore", location: "MG Road" },
        { id: 7, name: "Screen 7", city: "Delhi", location: "Connaught Place" },
        { id: 8, name: "Screen 8", city: "Mumbai", location: "Bandra" },
        { id: 9, name: "Screen 9", city: "Bangalore", location: "MG Road" },
        { id: 10, name: "Screen 10", city: "Delhi", location: "Connaught Place" },
    ];
    const devices = [
        { id: 1, name: "Device 1", screen: "Screen 1" },
        { id: 2, name: "Device 2", screen: "Screen 2" },
        { id: 3, name: "Device 3", screen: "Screen 3" },
        { id: 4, name: "Device 4", screen: "Screen 4" },
        { id: 5, name: "Device 5", screen: "Screen 5" },
        { id: 6, name: "Device 6", screen: "Screen 6" },
        { id: 7, name: "Device 7", screen: "Screen 7" },
        { id: 8, name: "Device 8", screen: "Screen 8" },
        { id: 9, name: "Device 9", screen: "Screen 9" },
        { id: 10, name: "Device 10", screen: "Screen 10" },
    ];
    const users = [
        { id: 1, name: "Admin 1", role: "Admin" },
        { id: 2, name: "User 1", role: "Viewer" },
        { id: 3, name: "User 2", role: "Editor" },
        { id: 4, name: "User 3", role: "Viewer" },
        { id: 5, name: "User 4", role: "Admin" },
        { id: 6, name: "User 5", role: "Editor" },
        { id: 7, name: "User 6", role: "Viewer" },
        { id: 8, name: "User 7", role: "Admin" },
        { id: 9, name: "User 8", role: "Editor" },
        { id: 10, name: "User 9", role: "Viewer" },
    ];

    const playlists = [
        { id: 1, name: "Playlist A", media: "Video 1" },
        { id: 2, name: "Playlist B", media: "Video 2" },
        { id: 3, name: "Playlist C", media: "Video 3" },
        { id: 4, name: "Playlist D", media: "Video 4" },
        { id: 5, name: "Playlist E", media: "Video 5" },
        { id: 6, name: "Playlist F", media: "Video 6" },
        { id: 7, name: "Playlist G", media: "Video 7" },
        { id: 8, name: "Playlist H", media: "Video 8" },
        { id: 9, name: "Playlist I", media: "Video 9" },
        { id: 10, name: "Playlist J", media: "Video 10" },
    ];
    const media = [
        { id: 1, name: "Video 1", url: "https://www.example.com/video1.mp4", media_type: "video" },
        { id: 2, name: "Video 2", url: "https://www.example.com/video2.mp4", media_type: "video" },
        { id: 3, name: "Video 3", url: "https://www.example.com/video3.mp4", media_type: "video" },
        { id: 4, name: "Video 4", url: "https://www.example.com/video4.mp4", media_type: "video" },
        { id: 5, name: "Video 5", url: "https://www.example.com/video5.mp4", media_type: "video" },
        { id: 6, name: "Video 6", url: "https://www.example.com/video6.mp4", media_type: "video" },
        { id: 7, name: "Video 7", url: "https://www.example.com/video7.mp4", media_type: "video" },
        { id: 8, name: "Video 8", url: "https://www.example.com/video8.mp4", media_type: "video" },
        { id: 9, name: "Video 9", url: "https://www.example.com/video9.mp4", media_type: "video" },
        { id: 10, name: "Video 10", url: "https://www.example.com/video10.mp4", media_type: "video" }
    ];

    const filteredScreens = screens.filter((s) => {
        return (
            (!selectedCity || s.city === selectedCity) &&
            (!selectedLocation || s.location === selectedLocation)
        );
    });

    const filteredDevices = devices.filter((d) =>
        filteredScreens.some((s) => s.name === d.screen)
    );

    const stats = {
        screens: filteredScreens.length,
        cities: cities.length,
        locations: locations.length,
        devices: filteredDevices.length,
        users: users.length,
        playlists: playlists.length,
        media: media.length
    };

    const hideCityAndLocationCards = selectedCity || selectedLocation;

    const openModal = (title, data, columns) => {
        setModalTitle(title);
        setModalData(data);
        setModalColumns(columns);
        setIsModalOpen(true);
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('userData'));
        const Permissions = user.permissions;
        // console.log(Permissions['users.view']==='1');
        setUserViewPermission(Permissions['users.view'] === '1');
        setCitiesViewPermission(Permissions['cities.view'] === '1');
        setLocationsViewPermission(Permissions['locations.view'] === '1');
    }, []);

    return (
        <div style={{ padding: "20px" }}>
            <Title level={2} style={{ marginBottom: "20px" }}>
                Dashboard
            </Title>

            <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
                <Col xs={24} sm={12} md={6}>
                    <Select
                        placeholder="Filter by City"
                        style={{ width: "100%" }}
                        onChange={setSelectedCity}
                        showSearch
                        allowClear
                    >
                        {cities.map((city) => (
                            <Option key={city.id} value={city.name}>
                                {city.name}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Select
                        placeholder="Filter by Location"
                        style={{ width: "100%" }}
                        onChange={setSelectedLocation}
                        showSearch
                        allowClear
                    >
                        {locations.map((loc) => (
                            <Option key={loc.id} value={loc.name}>
                                {loc.name}
                            </Option>
                        ))}
                    </Select>
                </Col>
            </Row>

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6}>
                    <StatCard
                        title="Screens"
                        value={stats.screens}
                        icon={<DesktopOutlined style={{ fontSize: "28px", color: "#1890ff" }} />}
                        link={`${process.env.REACT_APP_URL}/screens?city=${selectedCity}&location=${selectedLocation}`}
                    />
                </Col>
                {citiesViewPermission && !hideCityAndLocationCards && (
                    <Col xs={24} sm={12} md={6}>
                        <StatCard
                            title="Cities"
                            value={stats.cities}
                            icon={<EnvironmentOutlined style={{ fontSize: "28px", color: "#52c41a" }} />}
                            link={`${process.env.REACT_APP_URL}/cities`}
                        />
                    </Col>
                )}
                {locationsViewPermission && !hideCityAndLocationCards && (
                    <Col xs={24} sm={12} md={6}>
                        <StatCard
                            title="Locations"
                            value={stats.locations}
                            icon={<ClusterOutlined style={{ fontSize: "28px", color: "#faad14" }} />}
                            link={`${process.env.REACT_APP_URL}/locations`}
                        />
                    </Col>
                )}
                <Col xs={24} sm={12} md={6}>
                    <StatCard
                        title="Devices"
                        value={stats.devices}
                        icon={<TabletOutlined style={{ fontSize: "28px", color: "#eb2f96" }} />}
                        link={`${process.env.REACT_APP_URL}/devices?city=${selectedCity}&location=${selectedLocation}`}
                    />
                </Col>
                {userViewPermission && <Col xs={24} sm={12} md={6}>
                    <StatCard
                        title="Users"
                        value={stats.users}
                        icon={<UserOutlined style={{ fontSize: "28px", color: "#722ed1" }} />}
                        link={`${process.env.REACT_APP_URL}/users?city=${selectedCity}&location=${selectedLocation}`}
                    />
                </Col>}
                <Col xs={24} sm={12} md={6}>
                    <StatCard
                        title="Playlists"
                        value={stats.playlists}
                        icon={<PlaySquareOutlined style={{ fontSize: "28px", color: "#722ed1" }} />}
                        link={`${process.env.REACT_APP_URL}/playlists`}
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <StatCard
                        title="Media"
                        value={stats.media}
                        icon={<PictureOutlined style={{ fontSize: "28px", color: "#722ed1" }} />}
                        link={`${process.env.REACT_APP_URL}/library?status=1`}
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <StatCard
                        title="Pending Playlists"
                        value={5}
                        icon={<PictureOutlined style={{ fontSize: "28px", color: "#722ed1" }} />}
                        link={`${process.env.REACT_APP_URL}/playlists?status=0`}
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <StatCard
                        title="Pending Media"
                        value={5}
                        icon={<PictureOutlined style={{ fontSize: "28px", color: "#722ed1" }} />}
                        link={`${process.env.REACT_APP_URL}/library?status=0`}
                    />
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                <Col xs={24}>
                    <Card title="Top Playlists">
                        <Table
                            dataSource={playlists}
                            rowKey="id"
                            pagination={false}
                            columns={[
                                { title: "Playlist ID", dataIndex: "id" },
                                { title: "Name", dataIndex: "name" },
                                { title: "Media", dataIndex: "media" }, // Correctly displays the string
                            ]}
                        />
                    </Card>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                <Col xs={24}>
                    <Card title="Top Media">
                        <Table
                            dataSource={media}
                            rowKey="id"
                            pagination={false}
                            columns={[
                                { title: "Media ID", dataIndex: "id" },
                                { title: "Name", dataIndex: "name" },
                                { title: "URL", dataIndex: "url" },
                                { title: "Media Type", dataIndex: "media_type" },
                            ]}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Dashboard;
